import $ from 'jquery';

export default function sortModule() {
  const sortElement = $('.js-sort');
  if (sortElement.length) {
    return import(/* webpackChunkName: "sort" */ '../sort')
      .then(({ default: Sort }) => {
        const sort = new Sort();
        return sort;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
